// iter343 — Leads pipeline shared constants + helpers
import { differenceInCalendarDays } from "date-fns";

// Stage badges follow the house badge rule: standard text, pastel bg-x-100 / text-x-700 / border-x-200.
export const STAGES = [
  { value: "new", label: "New", pill: "bg-slate-100 text-slate-700 border-slate-200", dot: "bg-slate-400" },
  { value: "contacted", label: "Contacted", pill: "bg-sky-100 text-sky-700 border-sky-200", dot: "bg-sky-500" },
  { value: "in_progress", label: "In progress", pill: "bg-amber-100 text-amber-700 border-amber-200", dot: "bg-amber-500" },
  { value: "proposal_sent", label: "Proposal sent", pill: "bg-blue-100 text-blue-700 border-blue-200", dot: "bg-blue-500" },
];
export const CLOSED_STAGES = [
  { value: "won", label: "Won", pill: "bg-emerald-100 text-emerald-700 border-emerald-200", dot: "bg-emerald-500" },
  { value: "lost", label: "Lost", pill: "bg-red-100 text-red-700 border-red-200", dot: "bg-red-400" },
];
export const ALL_STAGES = [...STAGES, ...CLOSED_STAGES];
export const stageMeta = (v) => ALL_STAGES.find(s => s.value === v) || (v === "converted" ? CLOSED_STAGES[0] : STAGES[0]);

export const TEMPERATURES = [
  { value: "cold", label: "Cold", cls: "status-badge cold", pill: "bg-blue-100 text-blue-700 border-blue-200" },
  { value: "warm", label: "Warm", cls: "status-badge warm", pill: "bg-amber-100 text-amber-700 border-amber-200" },
  { value: "hot", label: "Hot", cls: "status-badge hot", pill: "bg-red-100 text-red-700 border-red-200" },
];
export const tempMeta = (v) => TEMPERATURES.find(t => t.value === v) || null;

export const ACTIVITY_TYPES = [
  { value: "call", label: "Call" },
  { value: "email", label: "Email" },
  { value: "text", label: "Text" },
  { value: "meeting", label: "Meeting" },
  { value: "site_visit", label: "Site visit" },
  { value: "note", label: "Note" },
];
export const activityLabel = (v) => ACTIVITY_TYPES.find(a => a.value === v)?.label || v || "—";

// A lead is stale after 30 days with no touch — it surfaces in the toolbar's "Stale" grouping (no row flag).
export const STALE_DAYS = 30;

export const lastTouch = (lead) => lead.last_activity_at || lead.updated_at || lead.created_at;
export const daysSinceTouch = (lead) => {
  const t = lastTouch(lead);
  return t ? differenceInCalendarDays(new Date(), new Date(t)) : null;
};
export const isOpenStage = (s) => STAGES.some(x => x.value === s);
export const isStale = (lead) => isOpenStage(lead.status) && (daysSinceTouch(lead) ?? 0) >= STALE_DAYS;
export const followUpOverdue = (lead) => lead.next_follow_up && !lead.follow_up_complete && new Date(lead.next_follow_up) < new Date();

export const money0 = (v) => new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2 }).format(v || 0);
